export default class SepaDirectDebitExport {
    static fromData(data) {
        if (!data) {
            return;
        }

        const sepaDirectDebitExport = new SepaDirectDebitExport();
        sepaDirectDebitExport.id = data.id;
        sepaDirectDebitExport.createdAt = data.createdAt;
        sepaDirectDebitExport.numberOfInvoices = data.numberOfInvoices;
        sepaDirectDebitExport.valuationDate = data.valuationDate;
        sepaDirectDebitExport.isZipFile = false;
        sepaDirectDebitExport.fileCount = 1;

        return sepaDirectDebitExport;
    }
}
